module.exports = require("pdf-lib");